import { Avatar, Dropdown, Space } from 'antd';
import { SketchPicker } from 'react-color';
import { GrispiInputProps } from '..';
import GrispiInputContainer from '../GrispiInputContainer';

type GrispiColorPickerInputProps = Omit<GrispiInputProps<'COLOR_PICKER'>, 'type' | 'isNewValueAllowed'>;

const GrispiColorPickerInput = ({
    containerProps,
    onChange,
    value,
    disabled,
    ...rest
}: GrispiColorPickerInputProps) => {
    return (
        <GrispiInputContainer {...containerProps}>
            <Dropdown
                trigger={['click']}
                disabled={disabled}
                {...rest}
                dropdownRender={() => (
                    <div>
                        <Space style={{ padding: 8 }}>
                            <SketchPicker color={value} onChangeComplete={onChange} />
                        </Space>
                    </div>
                )}
            >
                <a onClick={(e) => e.preventDefault()}>
                    <Space>
                        <Avatar style={{ backgroundColor: value as string }} />
                    </Space>
                </a>
            </Dropdown>
        </GrispiInputContainer>
    );
};

export default GrispiColorPickerInput;
